import styled from 'styled-components'
import { colors } from '../../../theme/variables_new'

export default styled.div`
    color: currentColor;
    vertical-align: baseline;
`
